import React, { useState } from 'react'

import { AllowPermission } from 'shared/components/AllowPermission'
import ErrorText from 'shared/components/forms/ErrorText'
import constants from 'config/constants'
import emptyLogo from './images/white-image.png'
import './styles.css'

export interface BrandLogoUploadProps {
  id: number | string
  imagePreview?: string | null
  file?: File | null
  handleImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

interface LogoPreviewProps {
  imagePreview?: string | null
}

function LogoPreview({ imagePreview }: LogoPreviewProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)

  if (!imagePreview) {
    return <img className="ss-brand-logo-upload-logo" src={emptyLogo} alt="empty-company-logo" />
  }

  if (failedSrc === imagePreview) {
    return (
      <div className="ss-brand-logo-upload-broken" role="status">
        <ErrorText>
          Logo file is broken.
          <AllowPermission permission={constants.permissions.manageBrands}>
            <br />
            Upload a new one.
          </AllowPermission>
        </ErrorText>
      </div>
    )
  }

  return (
    <img
      className="ss-brand-logo-upload-logo"
      src={imagePreview}
      alt="company-logo"
      onError={() => setFailedSrc(imagePreview)}
    />
  )
}

export default function BrandLogoUpload({
  id,
  imagePreview,
  file,
  handleImageUpload,
  disabled = false,
}: BrandLogoUploadProps) {
  const inputId = String(id)

  return (
    <div className="ui fluid card ss-brand-logo-upload">
      <div className="image">
        <LogoPreview imagePreview={imagePreview} />
      </div>
      <AllowPermission permission={constants.permissions.manageBrands}>
        <div className="content ui icon input loading">
          {file ? (
            <label htmlFor={inputId} className="ui fluid button ss-brand-logo-upload-button">
              <span>{file.name}</span>
            </label>
          ) : (
            <label
              htmlFor={inputId}
              className={disabled ? 'ui fluid button disabled' : 'ui fluid button'}
            >
              Upload image
            </label>
          )}
          <input
            id={inputId}
            className="ss-brand-logo-upload-input"
            type="file"
            onChange={handleImageUpload}
            disabled={disabled}
            accept="image/png, image/jpeg, image/gif"
          />
        </div>
      </AllowPermission>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/BrandLogoUpload/index.tsx